<template>
  <div>
    <el-row>
      <el-select v-model="territorial_value" placeholder="Choose data">
        <el-option
          v-for="item in territorial_options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-date-picker
        v-model="reports_date_range"
        class="float-right"
        type="daterange"
        unlink-panels
        range-separator="-"
        start-placeholder="Start date"
        end-placeholder="End date"
        :picker-options="dateRangeOptions"
        format="d MMMM yyyy"
        value-format="yyyy-MM-dd"
        @change="filter()"
      ></el-date-picker>
    </el-row>
    <el-row v-if="territorial_value === 'Videos'">
      <h1>Total Number of Videos by Channel Origin</h1>
      <el-col id="vid" :span="24" :lg="12">
        <GChart
          type="GeoChart"
          :settings="{
            packages: ['geochart'],
            mapsApiKey: 'AIzaSyCIVYFLXMrahuApcVFlAh1GIVGj2SNfqow'
          }"
          v-if="territorial_video"
          :data="territorial_video"
          :options="GeoChartSett"
        />
      </el-col>
      <el-col id="vid" :span="24" :lg="12">
        <GChart
          type="BarChart"
          :data="territorial_video"
          :options="BarChartSett"
        />
      </el-col>
    </el-row>
    <el-row v-if="territorial_value === 'Subscribers'">
      <h1>Total Number of Subscribers by Channel Origin</h1>
      <el-col id="sub" :span="24" :lg="12">
        <GChart
          type="GeoChart"
          :settings="{
            packages: ['geochart'],
            mapsApiKey: 'AIzaSyCIVYFLXMrahuApcVFlAh1GIVGj2SNfqow'
          }"
          v-if="territorial_subscribers"
          :data="territorial_subscribers"
          :options="GeoChartSett"
        />
      </el-col>
      <el-col id="sub" :span="24" :lg="12">
        <GChart
          type="BarChart"
          :data="territorial_subscribers"
          :options="BarChartSett"
        />
      </el-col>
    </el-row>
    <el-row v-if="territorial_value === 'Views'">
      <h1>Total Number of Views by Channel Origin</h1>
      <el-col id="vid" :span="24" :lg="12">
        <GChart
          type="GeoChart"
          :settings="{
            packages: ['geochart'],
            mapsApiKey: 'AIzaSyCIVYFLXMrahuApcVFlAh1GIVGj2SNfqow'
          }"
          v-if="territorial_views"
          :data="territorial_views"
          :options="GeoChartSett"
        />
      </el-col>
      <el-col id="vid" :span="24" :lg="12">
        <GChart
          type="BarChart"
          :data="territorial_views"
          :options="BarChartSett"
        />
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import { GChart } from 'vue-google-charts'
import format from 'date-fns/format'
import subDays from 'date-fns/subDays'
import addDays from 'date-fns/addDays'

export default {
  components: {
    GChart
  },

  data() {
    return {
      reports_date_range: [
        format(subDays(new Date(), 7), 'yyyy-MM-dd'),
        format(addDays(new Date(), 1), 'yyyy-MM-dd')
      ],
      territorial_value: 'Videos',
      territorial_options: [
        // {
        //   value: 'Artist',
        //   label: 'Artist'
        // },
        // {
        //   value: 'Tracks',
        //   label: 'Tracks'
        // },
        {
          value: 'Videos',
          label: 'Videos'
        },
        {
          value: 'Subscribers',
          label: 'Subscribers'
        },
        {
          value: 'Views',
          label: 'Views'
        },
        // {
        //   value: 'Channels',
        //   label: 'Channels'
        // }
      ]
    }
  },

  computed: {
    ...mapState('reportsTerritorial', [
      'loading',
      'date_range',
      'territorial',
      'BarChartSett',
      'GeoChartSett'
    ]),

    ...mapGetters('reportsTerritorial', [
      'territorial_video',
      'territorial_views',
      'territorial_subscribers'
    ])
  },

  methods: {
    ...mapActions('reportsTerritorial', ['readTerritorial']),
    ...mapMutations('reportsTerritorial', ['setDateRange']),

    filter() {
      this.setDateRange({
        start: this.reports_date_range[0],
        end: this.reports_date_range[1]
      }),
      this.readTerritorial({
        start: this.reports_date_range[0],
        end: this.reports_date_range[1]
      })
    }
  },

  created() {
    setTimeout(() => {
      this.filter()
    }, 1000)
  }
}
</script>

<style scoped>
h1 {
  text-align: center;
  font-weight: 200;
  font-size: 1.7rem;
}
.el-row {
  margin-top: 1rem;
}
</style>
